import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { AusModel } from '../../cmg-1003/models';
import { AusStore } from './aus.store';
import { DirtyChecker2 } from '../core/dirty-checker-2';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AusQuery extends Query<AusModel> {
  protected store: AusStore;

  // Store pending states for API calls
  isPendingLpa$ = new BehaviorSubject(false);
  isPendingDu$ = new BehaviorSubject(false);
  isPendingDuEa$ = new BehaviorSubject(false);
  isPendingAny$ = this._getAnyPending();
  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);

  constructor() {
    const store = inject(AusStore);

    super(store);
    this.store = store;

    this.dirtyChecker2.dirtyChecker.setHead();
  }

  /**
   * Check to see if there are any pending API calls
   * @private
   */
  private _getAnyPending() {
    return combineLatest([this.isPendingDu$, this.isPendingLpa$, this.isPendingDuEa$]).pipe(
      map(([isPendingDu, isPendingLpa, isPendingDuEa]) => isPendingDu || isPendingLpa || isPendingDuEa),
    );
  }
}
